import { render } from "./SubscriptionCard.vue?vue&type=template&id=68f10d3a&scoped=true"
import script from "./SubscriptionCard.vue?vue&type=script&lang=js"
export * from "./SubscriptionCard.vue?vue&type=script&lang=js"

import "./SubscriptionCard.vue?vue&type=style&index=0&id=68f10d3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f10d3a"]])

export default __exports__